import { Navigate } from "react-router-dom";

import { RVNestedRoutingPage } from "@regal-voice/ui";
import { AppPagePaths } from "App/routes/paths";
import { useFlags } from "Services/FeatureFlagService";

export default function BrandSecretsPage(): JSX.Element {
    const { showBrandSecrets } = useFlags();

    if (!showBrandSecrets) {
        return <Navigate to={AppPagePaths.fallback} replace />;
    }

    return <RVNestedRoutingPage />;
}
